export const environment = {
  production: true,
  keycloak: 'https://accounts.propertymatrix.co.za:8443',
  keycloakrealm: 'property-matrix',
  keycloakclient: 'property-matrix-app',
  api: 'https://api.propertymatrix.co.za',
  apiversion: "v1",
  riskscapeApiKey: "YQ0V4JTKTvHTFlMAmc9HpwHPebJDcc8h",
  pageUrl: "https://propertymatrix.co.za/#/",
  priceSliderMin: 1000000,
  priceSliderMax: 500000000
};
